<template>
  <div>
    FAQs under construction
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
